import React from "react";
import {
  Box,
  Button,
  DialogContent,
  DialogActions,
  Typography,
  Chip,
  alpha,
} from "@mui/material";
import CategoryIcon from "@mui/icons-material/Category";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Dialog } from "../../../../components/Dialogs/Dialog";
import { Flatware } from "@mui/icons-material";

interface SelectedCard {
  name: string;
  type: "service" | "venue" | "food";
}

interface ConfirmationCampaignProps {
  open: boolean;
  onClose: () => void;
  selectedCards: SelectedCard[];
  onConfirm: () => void;
}

const ConfirmationCampaign: React.FC<ConfirmationCampaignProps> = ({
  open,
  onClose,
  selectedCards,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      size="sm"
      title="Confirm Campaign Generation"
    >
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to auto-generate a WhatsApp campaign for the
          following selected cards?
        </Typography>

        {/* Selected Cards List */}
        <Box
          sx={{
            maxHeight: 250,
            overflowY: "auto",
            mb: 2,
            p: 1.5,
            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.04),
            borderRadius: 2,
            border: (theme) =>
              `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
          }}
        >
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {selectedCards.map((card, index) => (
              <Chip
                key={index}
                icon={
                  card.type === "service" ? (
                    <CategoryIcon sx={{ fontSize: 16 }} />
                  ) : card.type === "venue" ? (
                    <LocationOnIcon sx={{ fontSize: 16 }} />
                  ) : (
                    <Flatware sx={{ fontSize: 16 }} />
                  )
                }
                label={card.name}
                size="small"
                sx={{
                  backgroundColor: (theme) =>
                    card.type === "service"
                      ? alpha(theme.palette.success.main, 0.12)
                      : alpha(theme.palette.info.main, 0.12),
                  color: (theme) =>
                    card.type === "service"
                      ? theme.palette.success.dark
                      : theme.palette.info.dark,
                  fontWeight: 500,
                  fontSize: "0.8rem",
                  border: (theme) =>
                    `1px solid ${
                      card.type === "service"
                        ? alpha(theme.palette.success.main, 0.3)
                        : alpha(theme.palette.info.main, 0.3)
                    }`,
                  "& .MuiChip-icon": {
                    color: (theme) =>
                      card.type === "service"
                        ? theme.palette.success.main
                        : theme.palette.info.main,
                  },
                }}
              />
            ))}
          </Box>
        </Box>

        <Typography variant="body2" color="text.secondary">
          This action will create a marketing campaign targeting the selected
          leads with upselling opportunities.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Yes, Generate Campaign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationCampaign;
